import { Container, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useAuthContext } from 'src/auth/hooks';
import { useSettingsContext } from 'src/components/settings';
import { getTeleHealthPackages } from 'src/services/telehealth.service';
import TeleHealthPackageCard from 'src/components/therapy-package-card/therapy-package-card';
import AddTeleHealthPackageCard from 'src/components/therapy-package-card/therapy-package-card-add';

export default function ClinicTeleHealthPackagesView() {
  const navigate = useNavigate();
  const settings = useSettingsContext();
  const { user } = useAuthContext();
  const [cardData, setCardData] = useState([]);

  useEffect(() => {
    if (!user?.clinic_id) return;

    getTeleHealthPackages(user.clinic_id)
      .then((therapyList) => {
        if (!therapyList?.length) return;

        const tempCardData = therapyList.map((therapy) => ({
          id: therapy._id || therapy.id,
          clinic_id: user.clinic_id,
          therapy_name: therapy.therapy_name,
          promo_image: therapy.promo_image || '',
          is_active: Boolean(therapy.is_active),
          therapyCategory: therapy.therapyCategory,
          min_duration_months: therapy.min_duration_months,
          max_duration_months: therapy.max_duration_months,
        }));


        setCardData(tempCardData);
      })
      .catch((error) => {
        console.error('Error fetching telehealth therapies:', error);
      });
  }, [user?.clinic_id]);

  return (
    <Container maxWidth={settings.themeStretch ? false : 'xl'} sx={{ marginY: 3 }}>
      <Grid container spacing={2}>
        <Grid item lg={4} xl={3} xs={6}>
          <AddTeleHealthPackageCard />
        </Grid>
        {cardData.map((cardDetails) => (
          <Grid item xs={6} lg={4} xl={3} key={cardDetails.id}>
            <TeleHealthPackageCard cardDetails={cardDetails} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
